import {useState} from 'react';
import {useExternalServiceStore} from 'presentation/pages/private/store/externalSerivceUrlStore';
import {EndpointParamsProps} from './types';

export function useGetManualUrl(itemTitle: string) {
	const [isLoading, setIsLoading] = useState(false);
	const [isError, setIsError] = useState(false);

	const setExternalServiceUrl = useExternalServiceStore(state => state.setUrl);

	const getManualLink = async <T>(endpoint: EndpointParamsProps<T>, params?: T) => {
		if (!isLoading) {
			setIsLoading(true);
			try {
				const response = await endpoint().get(params);

				const manualsResponse = response;
				const firstManual = manualsResponse.manuals?.[0];
				const url = firstManual?.fileUrl;

				if (!url) {
					setIsError(true);
					return;
				}

				setExternalServiceUrl(itemTitle, url);

				window.open(url, '_blank', 'noopener,noreferrer');
			} catch (err) {
				setIsError(true);
			} finally {
				setIsLoading(false);
			}
		}
	};
	return {isLoading, isError, setIsLoading, setIsError, getManualLink};
}
